import React, { FC, Fragment } from 'react'
import { Route } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Header } from 'components'
import List from './View/List'

const Car: FC = () => {
  const { t } = useTranslation()

  return (
    <div>
      <Route path='/car/list' render={() =>
        <Fragment>
          <Header
            title={t("page_car_list_title")}
            description={t("page_car_list_description")}
          />
          <List />
        </Fragment>
      } />
    </div>
  )
}

export default Car
